import Lara from "@/presets/lara";

const convertStyleObjectsToArray = (styles: (string | object)[]) => {
  const flattenedStyles: string[] = [];
  styles.forEach((element) => {
    if (typeof element === "string") {
      flattenedStyles.push(element);
    } else {
      const filteredKeys = Object.entries(element)
        .filter(([, value]) => value)
        .map(([key]) => key);
      flattenedStyles.push(...filteredKeys);
    }
  });
  return flattenedStyles;
};

const stripElement = (styles: string[], elementRe: RegExp[]): string[] => {
  const flattenedStyles = convertStyleObjectsToArray(styles);
  return flattenedStyles.filter((s) => !elementRe.some((t) => t.test(s)));
};

/**
 * The gallery renders no prev/next arrows, so the only control over the photo is the indicator
 * dots — Lara's own styling carries those, and this preset just widens the layout to the card.
 */
export const excursionImagesPresets = {
  ...Lara,
  galleria: {
    ...Lara.galleria,
    root: { class: ["w-full"] },
    content: ({ parent, props }) => ({
      class: [
        ...(Array.isArray(Lara.galleria.content({ parent, props }).class)
          ? Lara.galleria.content({ parent, props }).class
          : [Lara.galleria.content({ parent, props }).class]),
        "w-full",
      ],
    }),
    indicators: ({ parent }) => ({
      class: [
        ...stripElement(Lara.galleria.indicators({ parent }).class, [/p-\d+/, /absolute*/]),
        "p-2 absolute z-10 bg-transparent",
      ],
    }),
    indicator: ({ parent }) => ({
      class: [...Lara.galleria.indicator({ parent }).class],
    }),
    indicatorbutton: ({ context }) => ({
      class: [...Lara.galleria.indicatorbutton({ context }).class],
    }),
  },
};
